var _a;
import { __decorate, __metadata } from "tslib";
import { ISCEService } from 'angular';
import { Component } from 'decorators';
import template from './UserMenu.html';
import './userMenu.scss';
import * as ArrowB from 'assets/img/ArrowB.png';
let UserMenuComponent = class UserMenuComponent {
    static $inject = ['$sce'];
    constructor($sce) {
        'ngInject';
        this.$sce = $sce;
        this.arrowBPath = ArrowB;
    }
    handleOnMenuOpen() {
        if (this.onMenuOpen) {
            this.onMenuOpen();
        }
    }
    setOpenMenu() {
        const e = document.getElementById('menuUser');
        e.open = !e.open;
    }
};
UserMenuComponent.$inject = ['$sce'];
UserMenuComponent = __decorate([
    Component({
        template,
        bindings: {
            user: '<',
            compact: '=?',
            onMenuOpen: '&',
        },
        transclude: true,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ISCEService !== "undefined" && ISCEService) === "function" ? _a : Object])
], UserMenuComponent);
export { UserMenuComponent };
